import { Fragment, useCallback, useMemo } from "react";
import { Modal, Tooltip } from "@mui/material";
import AddFolderIcon from "../../../assets/images/icons/AddFolderIcon.svg";
import Button from "../../UniversalComponents/DefaultButton";
import ReactTableComponent from "../../UniversalComponents/ReactTableComponent";
import Breadcrumb from "../../UniversalComponents/Breadcrumb";
import DocumentIcon from "../../../utils/utilityFunctions/iconUtility";

// Constants
const DISPLAY_NAME_KEY = "display_name";

const MoveDocumentModal = ({
  open,
  close,
  breadcrumpList,
  setBreadcrumpList,
  handleRowClick,
  headerData,
  handleBreadcrumpDataClicked,
  documentData,
  dataMove,
  handleOpenFolder,
  openFolderDialog,
  handlePaste,
}) => {
  const currentFolder = breadcrumpList[breadcrumpList.length - 1];

  const customizedBody = useMemo(() => {
    return headerData?.map((item) => {
      if (item?.accessor_key === DISPLAY_NAME_KEY) {
        return {
          ...item,
          selfContent: (data) => (
            <div className="flex flex-row gap-2">
              <span className="flex flex-row gap-2 items-center">
                {data.type === "folder" ? (
                  <DocumentIcon
                    type="folder"
                    className="cursor-pointer"
                    fill={data?.code}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenFolder(data);
                    }}
                  />
                ) : (
                  <DocumentIcon type={data.type} filename={data?.display_name} />
                )}
                <span>{data?.display_name?.substring(0, 20)}</span>
              </span>
            </div>
          ),
        };
      }
      return item;
    });
  }, [headerData, handleOpenFolder]);

  const handleMoveClick = useCallback(() => {
    handlePaste(currentFolder);
  }, [currentFolder, handlePaste]);

  const isMoveDisabled = useMemo(() => {
    return dataMove?.dirPath?.id === currentFolder?.id;
  }, [dataMove, currentFolder]);

  return (
    <Modal open={open} onClose={close}>
      <div className="min-h-[400px] max-w-[700px] py-2 w-full bg-white rounded shadow-md absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-2">
        {/* Header */}
        <div className="flex justify-between px-3 pb-1 border-b-[1px] border-gray-200 items-center">
          <span className="w-[220px] truncate">
            Move "<span className="font-bold text-blue-700">{dataMove?.display_name}</span>" Item To
          </span>
          <button aria-label="Close modal" onClick={close} className="text-lg font-bold cursor-pointer">
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div className="grow min-h-0 px-3 flex flex-col pb-2">
          {/* Table */}

          <ReactTableComponent
            tablename={
              <Breadcrumb
                breadcrumpList={breadcrumpList}
                setBreadcrumpList={setBreadcrumpList}
                handleClick={handleBreadcrumpDataClicked}
              />
            }
            headers={customizedBody || []}
            body={documentData || []}
            onRowClick={handleRowClick}
            actionField={
              <Tooltip
                placement="top"
                title="Add Folder"
                PopperProps={{
                  modifiers: [{ name: "offset", options: { offset: [0, -5] } }],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "black",
                      color: "white",
                      boxShadow: "none",
                      height: "23px",
                      display: "flex",
                      alignItems: "center",
                    },
                  },
                }}
              >
                <button
                  onClick={openFolderDialog}
                  type="button"
                  className="text-2541558A hover:text-254155 flex gap-1 w-[30px] items-center"
                >
                  <img className="w-full" src={AddFolderIcon} alt="New Folder Icon" />
                </button>
              </Tooltip>
            }
            narrowHeader
          />

          {/* Actions */}
          <div className="flex gap-4 justify-end">
            <Button variant="primary" onClick={handleMoveClick} isDisabled={isMoveDisabled}>
              Move Here
            </Button>
            <Button variant="secondary" onClick={close}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MoveDocumentModal;
